import { takeLatest, select, put, call } from "redux-saga/effects";
import { Orders } from "@grandvisionhq/api-client";
import { Selectors, Actions } from "@grandvisionhq/auth";
import { ApiConfigSelectors } from "@grandvisionhq/state";
import { unlinkOrder, unlinkOrderFailed, unlinkOrderSuccess } from "./actions.js";
function* onUnlinkOrder(action) {
  const auth = yield select(Selectors.getAuth);
  const formattedRoutes = yield select(
    Selectors.getFormattedRoutes
  );
  const getSuccessRoute = (orderNumber) => formattedRoutes?.unlinkOrder ? `${formattedRoutes.unlinkOrder}/success?orderNumber=${orderNumber}` : `unlink-order/success?orderNumber=${orderNumber}`;
  try {
    const apiConfig = yield select(ApiConfigSelectors.getApiConfig);
    if (!apiConfig) {
      yield put(unlinkOrderFailed(new Error("ApiConfig is unreachable")));
      return;
    }
    const { orderNumber, orderToken } = action.payload;
    const requestBody = { orderNumber, orderToken };
    yield call(Orders.unlink, auth.apiUrl, requestBody);
    yield put(unlinkOrderSuccess());
    yield put(Actions.goto({ path: getSuccessRoute(orderNumber) }));
  } catch (err) {
    yield put(unlinkOrderFailed({ ...err }));
  }
}
const unlinkOrderSagas = [takeLatest(unlinkOrder.type, onUnlinkOrder)];
export {
  unlinkOrderSagas as default,
  onUnlinkOrder
};
//# sourceMappingURL=sagas.js.map
